import React from "react";
import { Table } from "antd";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { PaginationConfig, SorterResult } from "antd/lib/table";

import { preRequestsTableColumns } from "../helpers";
import { IPreRequest } from "../../../../../types";
import { PaginatedResult } from "../../../../templates/requests/PendingRequestsTemplate";

interface IPreRequestsTemplateOwnProps {
  loading: boolean;
  onPaginationChange: (pagination: PaginationConfig, filters: any, sorter: SorterResult<any>) => void;
  preRequests: PaginatedResult<IPreRequest>;
}

type IPreRequestsTemplateProps =
  & IPreRequestsTemplateOwnProps
  & RouteComponentProps;

const PreRequestsTemplate: React.FC<IPreRequestsTemplateProps> = ({ loading, preRequests, onPaginationChange, history }) => {
  const goToDetails = (preRequestId: string = "") => {
    history.push(`/presolicitudes/${preRequestId}`);
  };

  const handleOnRowClick = (preRequest: IPreRequest) => {
    goToDetails(preRequest.id);
  };

  return (
    <div style={{ backgroundColor: "#FFF", padding: "25pt" }}>
      <Table
        loading={loading}
        onRowClick={handleOnRowClick}
        bodyStyle={{ minHeight: "400pt" }}
        pagination={{ total: preRequests?.count }}
        dataSource={preRequests?.items || []}
        onChange={onPaginationChange}
        columns={preRequestsTableColumns} />
    </div>
  );
};

export default withRouter(PreRequestsTemplate);
